
namespace TabAurous.Finance {

    @Serenity.Decorators.registerClass()
    export class PDCPayableGrid extends _Ext.GridBase<PDCPayableRow, any> {
        protected getColumnsKey() { return 'Finance.PDCPayable'; }
        protected getDialogType() { return PDCPayableDialog; }
        protected getIdProperty() { return PDCPayableRow.idProperty; }
        protected getInsertPermission() { return PDCPayableRow.insertPermission; }
        protected getLocalTextPrefix() { return PDCPayableRow.localTextPrefix; }
        protected getService() { return PDCPayableService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected addButtonClick() {

            let now = new Date();

            var voucherNo = FormatHelper.GetVoucherNo(7);
            this.editItem(<PDCPayableRow>{
                VoucherNo: voucherNo,
                TransDate: now.toString(),
                CreatedBy: Q.Authorization.userDefinition.UserId.toString(),
                VoucherTypeId: 7,
                FinancialYearId: Q.Authorization.userDefinition.FinancialYearId,
                CompanyId: Q.Authorization.userDefinition.CompanyId,
                Status: "Not Cleared"

            });
        }
    }
}